import { v1ApiClient } from '@/services';
import type { Operation } from '@/shared/api/generated';

type DeleteStudioItemOperation = Operation<'DeleteHeySynclyStudioItem'>;

export type DeleteStudioItemParams =
  DeleteStudioItemOperation['parameters']['path'];

export const deleteStudioItem = ({ item_id }: DeleteStudioItemParams) =>
  v1ApiClient.delete(`/hey-syncly/studio/items/${item_id}`).then((res) => res.data);
